module.exports = __webpack_public_path__ + "assets/img/NPC027.efb57ac7.png";